import { parseDomain } from './parser';
const TopRecommendationLabel = {
  EXACT_MATCH: 'EXACT_MATCH',
  BEST_MATCH: 'BEST_MATCH',
  GREAT_ALTERNATIVE: 'GREAT_ALTERNATIVE'
};
export const findDomainInQuery = query => {
  const domain = query.replace(/\.(\s|$)/g, ' ').split(' ').find(word => {
    const hasTld = word.includes('.');
    return hasTld && !parseDomain(word.trim()).error;
  });
  return domain ? parseDomain(domain) : undefined;
};
export const withTopRecommendations = (query, baseRecommendations) => {
  const firstSuggestion = baseRecommendations[0],
    secondSuggestion = baseRecommendations[1],
    restOfSuggestions = baseRecommendations.slice(2);
  if (!(firstSuggestion != null && firstSuggestion.domain)) {
    return baseRecommendations;
  }
  const labeled = (suggestion, label) => ({
    ...suggestion,
    label
  });
  const searchedDomain = parseDomain(query);
  const domainInQuery = findDomainInQuery(query);
  const parsedFirstSuggestion = parseDomain(firstSuggestion.domain);
  const queryIncludesTld = query.endsWith(`.${searchedDomain.tld}`);
  const greatAlternative = secondSuggestion ? [labeled(secondSuggestion, TopRecommendationLabel.GREAT_ALTERNATIVE)] : [];

  // First suggestion is exact match and search includes TLD
  if (parsedFirstSuggestion.asciiDomain === (domainInQuery == null ? void 0 : domainInQuery.asciiDomain)) {
    return [labeled(firstSuggestion, TopRecommendationLabel.EXACT_MATCH), ...greatAlternative, ...restOfSuggestions];
  }

  // Searched only SLD
  if (parsedFirstSuggestion.sld === searchedDomain.sld && !queryIncludesTld) {
    return [labeled(firstSuggestion, TopRecommendationLabel.BEST_MATCH), ...greatAlternative, ...restOfSuggestions];
  }

  // Query is either unavailable domain or not a domain/sld
  return [labeled(firstSuggestion, queryIncludesTld || domainInQuery != null && domainInQuery.tld ? TopRecommendationLabel.GREAT_ALTERNATIVE : TopRecommendationLabel.BEST_MATCH), secondSuggestion, ...restOfSuggestions].filter(suggestion => Boolean(suggestion));
};
//# sourceMappingURL=topRecommendations.js.map